<template>
  <div style="text-align: center;">
    <p style="margin-top: 15px;"><strong>{{ data.community.name }}</strong> exists but is not associated with <span v-html="associatedMessage" />. Would you like to associate them?</p>
    <div class="row">
      <div class="col-md-2"></div>
      <div class="col-md-8" style="padding-left: 30px;">
        <p-checkbox class="text-left" v-model="addClient" v-if="data.client">
          <strong>Client:</strong> {{ data.client.name }}
        </p-checkbox>
        <p-checkbox class="text-left" v-model="addBuilder" v-if="data.builder">
          <strong>Builder:</strong> {{ data.builder.name }}
        </p-checkbox>
      </div>
      <div class="col-md-2"></div>
    </div>
    <button type="button" @click="associateAndSave" class="btn btn-fill btn-info" :disabled="noClientOrBuilderSelected">
      Yes
    </button>
    <button type="button" @click="closeModal" class="btn btn-fill btn-info">
      No
    </button>
  </div>
</template>

<script>
  import {notifySuccess, notifyError} from 'src/utilities/utils'
  import Constants from 'src/utilities/constants'

  export default {
    props: ['data'],
    computed: {
      noClientOrBuilderSelected() {
        return !this.addClient && !this.addBuilder
      },
      associatedMessage() {
        if (this.data.client && this.data.builder) {
          return 'client: <i>' + this.data.client.name + '</i> or builder: <i>' + this.data.builder.name + '</i>'
        } else if (this.data.client) {
          return 'client: <i>' + this.data.client.name + '</i>'
        } else if (this.data.builder) {
          return 'builder: <i>' + this.data.builder.name + '</i>'
        }
      }
    },
    data() {
      return {
        addClient: false,
        addBuilder: false,
        communityAssociated: false
      }
    },
    methods: {
      async associateAndSave() {
        const payload = {
          endpoint: 'communities',
          id: this.data.community.id,
        }
        if (this.addClient
          && this.data.client
          && this.data.client.id
          && !this.data.community.clientIds.includes(this.data.client.id)) {
          this.data.community.clientIds.push(this.data.client.id)
        }
        if (this.addBuilder
          && this.data.builder
          && this.data.builder.id
          && !this.data.community.builderIds.includes(this.data.builder.id)) {
          this.data.community.builderIds.push(this.data.builder.id)
        }

        payload.data = this.data.community

        const response = await this.$store.dispatch('save', payload)

        if (response.result === Constants.RETURN_CODES.SUCCESS) {
          notifySuccess(this, 'Community associated with client and/or builder successfully')
          this.$eventHub.$emit('communitySaved', response.data)
          this.communityAssociated = true
          this.$emit('close')
          return
        }
        notifyError(this, 'Failed to associate community with client and/or builder')
      },
      closeModal() {
        this.$emit('close')
      }
    },
    destroyed() {
      if (!this.communityAssociated) {
        this.$eventHub.$emit('noCommunitySelected')
      }
    }
  }
</script>
